import React from 'react';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();

  return (
    <header style={{
      backgroundColor: 'var(--black)',
      color: 'var(--white)',
      padding: '1rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: 'var(--shadow)',
    }}>
      <div className="d-flex align-center">
        <div className="d-flex align-center" style={{ marginRight: '1rem' }}>
          <img
            src="https://taxntips.com/nav-logo.png"
            alt="TaxnTip Logo"
            style={{
              height: '40px',
              width: 'auto',
              marginRight: '1rem',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>

      </div>

      <div className="d-flex align-center">
        <span style={{ marginRight: '1rem' }}>
          Welcome, {user?.name || user?.email}
        </span>
        <button
          onClick={logout}
          className="btn btn-secondary"
          style={{
            backgroundColor: 'transparent',
            border: '1px solid var(--border-color)',
            color: 'var(--white)',
          }}
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
